// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__2-J4C","title":"styles_title__J8OOi","value":"styles_value__2fnkt"};